import {UserEditModalForm} from './UserEditModalForm'
import {useListView} from '../providers/ListViewProvider'
import {useEffect, useState} from "react";
import {Employee} from "@providers/employee/_request";
import {useParams} from "react-router-dom";
import {useErrors} from "@providers/context/ErrorsProvider";
import {AdminModalForm} from "./AdminModalForm";
import {Admins} from "@providers/admins/_request";

const UserEditModalFormWrapper = () => {
  const {itemIdForUpdate} = useListView()
  const {error,setError} = useErrors()
  const [isLoading, setLoading] = useState(false)
  const [employee, setEmployee] = useState(null)




  const param = useParams()


  useEffect(()=>{

    if(param.companyId&&itemIdForUpdate){
      setLoading(true)
      Employee.getEmployeeById(param.companyId, itemIdForUpdate)
          .then(result=>{
            setLoading(false)
            setEmployee(result?.data?.result)
          }).catch(err=>{
            setLoading(false)
            setError({status: err?.response?.status, message: err?.response?.data?.message, isError: true})
          })
    }else if(param['*']?.match('admin')&&itemIdForUpdate){

      Admins.getOneAdmin(itemIdForUpdate)
          .then(result=>{
              setEmployee(result?.data?.result)
          }).catch(err=>{
        setLoading(false)
        setError({status: err?.response?.status, message: err?.response?.data?.message, isError: true})
      })
    }

  }, [itemIdForUpdate])


  if (!itemIdForUpdate&&param['*']?.match('admins')) {
    return <AdminModalForm isUserLoading={isLoading} user={{id: undefined}} />
  }


  if (!itemIdForUpdate) {
    return <UserEditModalForm isUserLoading={isLoading}  />
  }

  if (!isLoading && !Object.keys(error).length && employee && param['*']?.match('admin')) {
    return <AdminModalForm isUserLoading={isLoading} user={employee} />
  }

  if (!isLoading && !Object.keys(error).length && employee) {
    return <UserEditModalForm isUserLoading={isLoading} user={employee} />
  }




  return null
}

export {UserEditModalFormWrapper}
